var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5459 17.874C14.083 17.874 14.3838 17.4873 14.3838 16.9072V14.4473H14.6953C17.3379 14.4473 18.7236 13.0293 18.7236 10.4297V4.17773C18.7236 1.57812 17.3379 0.149414 14.6953 0.149414H4.02832C1.38574 0.149414 0 1.57812 0 4.17773V10.4297C0 13.0293 1.38574 14.4473 4.02832 14.4473H9.4209L12.4609 17.2617C12.9121 17.6807 13.1699 17.874 13.5459 17.874Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback_icon.d46805be66a42bd2e9882c7d2399550b.svg";
export { ForwardRef as ReactComponent };